export default __webpack_public_path__ + "static/wegift-blue.url-df5f601cc14de9a80733f128b48023af.svg";